import $ from 'jquery';
// import * as Hammer from './Hammer';

export default {
  data() {
    return {
      svgpanzoom: null,
      customEventsHandler: {
        // haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
        init: (options) => this.init(options),
        destroy: (options) => this.destroy(options),
      },
    };
  },
  methods: {
    registerSvgPanZoom(svgpanzoom) {
      this.svgpanzoom = svgpanzoom;
    },
    init(options) {
      // const { instance } = options;
      // let initialScale = 1;
      // let pannedX = 0;
      // let pannedY = 0;
      // // Init Hammer
      // // Listen only for pointer and touch events
      // this.hammer = Hammer(options.svgElement, {
      //   inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput,
      // });

      // // Enable pinch
      // this.hammer.get('pinch').set({ enable: true });
      // // Handle pan
      // this.hammer.on('panstart panmove', (ev) => {
      //   // On pan start reset panned variables
      //   if (ev.type === 'panstart') {
      //     pannedX = 0;
      //     pannedY = 0;
      //   }
      //   // Pan only the difference
      //   instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY });
      //   pannedX = ev.deltaX;
      //   pannedY = ev.deltaY;
      // });

      // // Handle pinch
      // this.hammer.on('pinchstart pinchmove', (ev) => {
      //   // On pinch start remember initial zoom
      //   if (ev.type === 'pinchstart') {
      //     initialScale = instance.getZoom();
      //     instance.zoomAtPoint(initialScale * ev.scale, {
      //       x: ev.center.x,
      //       y: ev.center.y,
      //     });
      //   }

      //   instance.zoomAtPoint(initialScale * ev.scale, {
      //     x: ev.center.x,
      //     y: ev.center.y,
      //   });
      // });
      // // Prevent moving the page on some devices when panning over SVG
      // options.svgElement.addEventListener('touchmove', (e) => {
      //   e.preventDefault();
      // });

      this.$emit('current-SVGElement', options.svgElement);
      $(options.svgElement).on('click', 'path[title],ellipse[title]', this.handleClick);
    },
    destroy(options) {
      options.svgElement.removeEventListener('click', this.handleClick);
      this.hammer.destroy();
    },
    handleClick(e) {
      const part = $(e.currentTarget).attr('title');
      const selectd = $(e.currentTarget).attr('selected');
      const arr = [].concat(this.selectedParts ?? []);
      this.$emit('current-part', '');
      if (selectd) {
        $(e.currentTarget).css('fill-opacity', 0);
        $(e.currentTarget).removeAttr('selected');
        const index = arr.findIndex((v) => v === part);
        arr.splice(index, 1);
        this.$emit('current-part', '');
      } else {
        $(e.currentTarget).css('fill-opacity', 0.56);
        $(e.currentTarget).attr('selected', 'true');
        arr.push(part);
        const str = part.split('-')[0];
        this.$emit('current-part', str);
      }
      this.$emit('selected-parts', arr);
    },
  },
};
